import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const ticketDataClassName = DataClassName.TICKET
const ticketEndpoint = PisaDataClassEndpoint.TICKET

export function pisaTicketDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(ticketDataClassName, {
    title: ticketDataClassName,
    restApi: createPisaRestApiConfig(ticketEndpoint),
    attributes,
  })
}
